import type { Connection, MatterExpense } from "@/lib/types";
import {
  createContactConnectionChildInput,
  getActiveContactConnections,
} from "./item-contact-connections";

const EXPENSE_PAYEE_CONNECTION_TYPES = [
  "matter_expense_to_payee",
  "matter_expense_to_legacy_payee",
] as const;

export const getExpensePayeeConnections = (
  expense: MatterExpense | undefined,
): Connection[] =>
  EXPENSE_PAYEE_CONNECTION_TYPES.flatMap((connectionType) =>
    getActiveContactConnections(expense, "matter_expense", connectionType),
  );

export const getExpensePayeeConnection = (expense?: MatterExpense) =>
  getExpensePayeeConnections(expense)[0] as Connection | undefined;

export const createExpensePayeeConnectionChildInput = (contactId: string) =>
  createContactConnectionChildInput(contactId, "matter_expense_to_payee");

export const EXPENSE_PAYEE_CONNECTION_TYPE = "matter_expense_to_payee";
